
const NombreDia = ({ dia }) => {
  const nombreCorto = dia.slice(0, 3); // first 3 letters

  return (
    <div
      className="nombreDiaHorario"
      data-short={nombreCorto}
    >
      <span className="nombreCompleto">{dia}</span>
    </div>
  );
};

export default NombreDia;
